import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class StartAnalysisService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.error = false;
        this.analysisSubject = new BehaviorSubject(false);
        this.analysisObservable = this.analysisSubject.asObservable();
    }
    sendEfa(analyzeForm, fileName, includedIcr, ezshared, pageMin, pageMax, icrFileName) {
        this.efaPostData = {
            file: fileName,
            operationNumber: analyzeForm.operationNumber.toUpperCase(),
            language: analyzeForm.language,
            initDateStr: this.formatDate(analyzeForm.auditDate[0]),
            endDateStr: this.formatDate(analyzeForm.auditDate[1]),
            includeIcr: includedIcr,
            ezsharedLink: ezshared,
            icrInitPage: pageMin,
            icrEndPage: pageMax,
            file_icr: icrFileName,
        };
        return this.httpClient.post(environment.api.base + 'efas', this.efaPostData);
    }
    start(analyzeForm, fileName, includedIcr, ezshared, pageMin, pageMax, icrFileName) {
        this.efaPostData = {
            file: fileName,
            operationNumber: analyzeForm.operationNumber.toUpperCase(),
            language: analyzeForm.language,
            initDateStr: this.formatDate(analyzeForm.auditDate[0]),
            endDateStr: this.formatDate(analyzeForm.auditDate[1]),
            includeIcr: includedIcr,
            ezsharedLink: ezshared,
            icrInitPage: pageMin,
            icrEndPage: pageMax,
            file_icr: icrFileName,
        };
        console.log("start");
        return this.httpClient.post(environment.api.base + 'analysis/start', this.efaPostData);
    }
    status(analyzeForm, fileName, includedIcr, ezshared, pageMin, pageMax, icrFileName, queueId) {
        this.efaPostData = {
            file: fileName,
            operationNumber: analyzeForm.operationNumber.toUpperCase(),
            language: analyzeForm.language,
            initDateStr: this.formatDate(analyzeForm.auditDate[0]),
            endDateStr: this.formatDate(analyzeForm.auditDate[1]),
            includeIcr: includedIcr,
            ezsharedLink: ezshared,
            icrInitPage: pageMin,
            icrEndPage: pageMax,
            file_icr: icrFileName,
            queueId: queueId
        };
        return this.httpClient.post(environment.api.base + 'analysis/status', this.efaPostData);
    }
    getIcrRadio(analyzeForm) {
        return analyzeForm === 'inFile';
    }
    setAnalysisData(analysisData) {
        this.analysisSubject.next(analysisData);
    }
    getAnalysis() {
        return this.analysisObservable;
    }
    formatDate(date) {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('/');
    }
}
StartAnalysisService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StartAnalysisService_Factory() { return new StartAnalysisService(i0.ɵɵinject(i1.HttpClient)); }, token: StartAnalysisService, providedIn: "root" });
